<template>
  <div>
    <template v-if="!allItems.length">
      <NotFound height="250px" :message="notItemsFoundText" />
    </template>
    <template v-else>
      <TableColumns
        :all-columns-prop="allItems"
        background-color="kbLight"
        :is-component-opened="isMenuOpened"
        :loading="loading"
        :selected-columns-prop="selectedItems"
        :text-key="textKey"
        :value-key="valueKey"
        @closeComponent="closeMenu()"
        @onColumnsChange="onColumnsChange"
      />
    </template>
  </div>
</template>

<script>
import TableColumns from '@/components/widgets/TableColumns'
import NotFound from '@/components/ui/NotFound'
export default {
  components: { NotFound, TableColumns },
  methods: {
    closeMenu () {
      this.$emit('closeComponent')
    },
    onColumnsChange (columns) {
      this.$emit('onColumnsChange', columns)
    }
  },
  props: {
    allItems: {
      type: Array,
      default: () => []
    },
    isMenuOpened: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    notItemsFoundText: {
      type: String,
      default: ''
    },
    selectedItems: {
      type: Array,
      default: () => []
    },
    textKey: {
      type: String,
      default: 'text'
    },
    valueKey: {
      type: String,
      default: 'value'
    }
  }
}
</script>
